import { CommonGet, CommonPost, CommonGetIDServer } from "../../../utils/CommonFetch";
import tokenDecoder from '../../../components/Common/tokenDecoder';

export default {
    saveTaskTemplate,
    editTaskTemplate,
    getGroups,
    getEstatesByGroupID,
    getDivisions,
    getAllByFilter,
    getAllTaskNames,
    getGridByFilter,
    getFields,
    getFeildsByTemplateID,
    GetAllOperationEntityByGroupID,
    getLabourTaskByOperationEntityIDTaskCategoryID,
    GetCollectionPointByOperationEntityIDLabourTaskID
};

async function saveTaskTemplate(data, feildList, stateData) {
    const formData = {
        employeeTaskTemplateID: parseInt(data.employeeTaskTemplateID),
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
        estateTaskID: parseInt(data.estateTaskID),
        taskExpiration: data.taskExpiration,
        fieldList: feildList,
        numberOfWorkers: parseInt(data.numberOfWorkers),
        sundryTask: parseInt(data.sundryTask),
        collectionPointID: parseInt(data.collectionPointID),
        createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
        createdDate: new Date().toISOString(),
        circulation: stateData,
        isActive: data.isActive

    }
    var result = await CommonPost('/api/TaskTemplate/SaveTaskTemplate', null, formData);
    return result;
}

async function getLabourTaskByOperationEntityIDTaskCategoryID(operationEntityID, estateTaskID) {
    const response = await CommonGet('/api/EstateTask/GetLabourTaskByOperationEntityIDTaskCategoryID', 'operationEntityID=' + operationEntityID + '&taskCategoryID=' + estateTaskID);
    let array = []
    for (let item of Object.entries(response.data)) {

        array[item[1]["taskID"]] = item[1]["taskName"]

    }
    return array;
}

async function GetCollectionPointByOperationEntityIDLabourTaskID(operationEntityID,sundryTask) {
    let response = await CommonGet('/api/EstateTask/GetCollectionPointByOperationEntityIDLabourTaskID', 'operationEntityID=' + operationEntityID + '&labourTaskID=' + sundryTask);
    return response.data;
}

async function editTaskTemplate(data,feildList,stateData) {
    const formData = {
        employeeTaskTemplateID: parseInt(data.employeeTaskTemplateID),
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
        estateTaskID: parseInt(data.estateTaskID),
        taskExpiration: data.taskExpiration,
        fieldList: feildList,
        numberOfWorkers: parseInt(data.numberOfWorkers),
        sundryTask: parseInt(data.sundryTask),
        collectionPointID: parseInt(data.collectionPointID),
        modifiedBy: parseInt(tokenDecoder.getUserIDFromToken()),
        modifiedDate: new Date().toISOString(),
        circulation: stateData,
        isActive: data.isActive
    }
    var result = await CommonPost('/api/TaskTemplate/Update', null, formData);

    return result;
}

async function GetAllOperationEntityByGroupID(groupID) {
    const dataArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllOperationEntityByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return dataArray;
}

async function getAllByFilter(groupId, estateId) {
    var response = await CommonGet('/api/TaskTemplate/GetTaskTemplatesByFilter', 'groupID=' + groupId + '&estateId=' + estateId);
    return response.data;
}


async function getGroups() {
    let response = await CommonGet('/api/Group/GetAllGroups', null);
    let groupArray = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getDivisions(estateID) {
    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateID=' + estateID);
    let array = []
    for (let item of Object.entries(response.data)) {

        array[item[1]["collectionPointID"]] = item[1]["collectionPointName"]

    }
    return array;
}

async function getEstatesByGroupID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetAllEstates', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true && item[1]["groupID"] == groupID) {
            array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return array;
}

async function getAllTaskNames(groupID, operationEntityID) {
    const response = await CommonGet('/api/EstateTask/GetEstateTaskByFilter', 'groupID=' + groupID + '&operationEntityID=' + operationEntityID);
    let array = []
    for (let item of Object.entries(response.data)) {

        array[item[1]["estateTaskId"]] = item[1]["estateTaskName"]

    }
    return array;
}

async function getGridByFilter(groupId, estateId) {
    var response = await CommonGet('/api/TaskTemplate/GetTemplatesByFilter', 'groupID=' + groupId + '&estateId=' + estateId);
    response.data.forEach(x => {
        x.taskExpiration = x.taskExpiration === null ? null :x.taskExpiration.split('T')[0];
    });
    return response.data;
}

async function getFields(groupID, operationEntityID, collectionPointID) {
    var filterModel = {
        groupID: groupID.toString(),
        operationEntityID: operationEntityID.toString(),
        collectionPointID: collectionPointID.toString()
    }
    const response = await CommonPost('/api/Field/FilterFields', null, filterModel);
    return response.data;
}

async function getFeildsByTemplateID(taskTemplateID) {
    var response = await CommonGet('/api/Field/GetFieldsByTaskTemplateID', 'id=' + parseInt(taskTemplateID));
    return response.data;
}
